module.exports = __webpack_public_path__ + "img/template30.01154562.png";